<!---数据统计--->
<template>
  <div>
    <list
      row-key="BillId"
      ref="list"
      unit="人员对账单"
      :page="page"
      show-checkbox
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="对账月份">
          <el-date-picker
            v-model="params.StartDate"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
          />
        </el-form-item>
        <el-form-item label="人员类别">
          <el-select v-model="params.MemberType" placeholder="请选择人员类别" clearable>
            <el-option label="学生" :value="0"></el-option>
            <el-option label="教职人员" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="YearMonth" label="对账月份" width="90" />
        <el-table-column prop="Amount" label="对账日期" min-width="170px">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.StartDate)}}</span>
            <span style="margin: 3px;">至</span>
            <span>{{$commonJs.toDateString(row.EndDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Sort" label="人员类别" width="90">
          <template slot-scope="{row}">
            <span v-if="row.MemberType==0">学生</span>
            <span v-if="row.MemberType==1">教职人员</span>
          </template>
        </el-table-column>
        <el-table-column prop="MemberCount" label="对账人数" width="90" />
        <el-table-column prop="BeginTotalBalance" label="期初总余额" width="90" />
        <el-table-column prop="RechargeAmount" label="账号充值总金额" width="110" />
        <el-table-column prop="WxTradeAmount" label="微信到账总金额" width="110" />
        <el-table-column prop="GiveAmount" label="后台充值总金额" width="110" />
        <el-table-column prop="ConsumeAmount" label="账号消费总金额" width="110" />
        <el-table-column prop="DeviceAmount" label="机器消费总金额" width="110" />
        <el-table-column prop="RefundAmount" label="退款总金额" width="110" />
        <el-table-column prop="EndTotalBalance" label="账号剩余总余额" width="110" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/cp/bill").default,
      params: {
        StartDate: null,
        MemberType: null,
      },
    };
  },
  methods: {
    reBuild(row) {
      this.api.build(row.StartDate, row.MemberType).then((res) => {
        if (res.Code == 0) {
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>